import React from 'react'
import {
    Button,
} from "reactstrap";

const propTypes = {};

class ScheduleCellItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            event: props.event
        };
    }

    handleSelect = (e) => {
        e.preventDefault();
        switch (this.state.event.event_type) {
            case undefined:
                this.props.goToClass(this.state.event.id, "ScheduleCellItem");
                break;
            case "event_event":
                this.props.openEvent(this.state.event);
                break;
            case "event_reminder":
                this.props.openEvent(this.state.event);
                break;
            default:
                this.props.goToClass(this.state.event.id, "ScheduleCellItem");
                break;
        }
    };

    render() {
        return (
            <>
                {this.state.event !== undefined &&
                <div className="shadow col-lg-12"
                     onClick={e => this.handleSelect(e)}>
                    <div style={{marginStart: 0, marginLeft: 0, width: '100%'}}>
                        <Button
                            color={this.selectColorForEvent()}
                            size="sm"
                            style={{textAlign: "left", width: '100%', marginBottom: 0, fontSize: "0.55rem", overflow: "hidden"}}
                        >
                            {this.thisIsClass() ?
                            (<div className="text-center" style={{
                                height: "8px",
                                width: "8px",
                                borderRadius: "3px",
                                backgroundColor: this.classColor(),
                            }}><span style={{marginLeft: "12px", width: "100%", overflow: "hidden"}}>{this.eventTitle()} </span></div>) :
                                (<span style={{width: "100%", overflow: "hidden"}}>{this.eventTitle()}</span>)
                            }
                        </Button>
                    </div>
                </div>
                }
            </>
        )
    }

    selectColorForEvent() {
        switch (this.state.event.event_type) {
            case undefined:
                return "secondary";
            case "event_event":
                return "success";
            case "event_reminder":
                return "info";
            default:
                return "secondary";
        }
    }

    eventTitle() {
        return this.state.event !== undefined && this.state.event.name !== undefined ? this.state.event.name : this.state.event !== undefined ? this.state.event.title : ""
    }

    thisIsClass() {
        return this.state.event.event_type === undefined
    }

    classColor() {
        return this.state.event.clr ? `#${this.state.event.clr}` : "white"
    }
}

ScheduleCellItem.propTypes = propTypes;

export default ScheduleCellItem;